"use client";

import Link from "next/link";
import { useRouter } from "next/navigation";

// Icons
import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
import HomeIcon from "@mui/icons-material/Home";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export default function NotFound() {
  const router = useRouter();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        {/* CTribe Logo/Branding */}
        <div className="mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-custom-gray text-white mb-4">
            <SentimentDissatisfiedIcon style={{ fontSize: 48 }} />
          </div>
        </div>

        {/* Error Message */}
        <h1 className="text-6xl font-bold text-custom-gray mb-2">404</h1>
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          Page Not Found
        </h2>
        <p className="text-gray-500 mb-8">
          Oops! The page you&apos;re looking for doesn&apos;t exist or has been moved.
          Let&apos;s get you back on track.
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={() => router.back()}
            className="inline-flex items-center justify-center gap-2 px-6 py-3 border-2 border-custom-gray text-custom-gray rounded-xl hover:bg-gray-50 transition-colors font-medium"
          >
            <ArrowBackIcon style={{ fontSize: 20 }} />
            Go Back
          </button>
          <Link
            href="/"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-custom-gray text-white rounded-xl hover:bg-gray-800 transition-colors font-medium"
          >
            <HomeIcon style={{ fontSize: 20 }} />
            Back to Home
          </Link>
        </div>

        {/* Quick Links */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <p className="text-sm text-gray-500 mb-4">Or try these popular pages:</p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link
              href="/schedule"
              className="text-sm text-custom-gray hover:underline"
            >
              Schedule
            </Link>
            <span className="text-gray-300">•</span>
            <Link
              href="/passes"
              className="text-sm text-custom-gray hover:underline"
            >
              My Pass
            </Link>
            <span className="text-gray-300">•</span>
            <Link
              href="/profile"
              className="text-sm text-custom-gray hover:underline"
            >
              Profile
            </Link>
            <span className="text-gray-300">•</span>
            <Link
              href="/workspaces"
              className="text-sm text-custom-gray hover:underline"
            >
              Workspaces
            </Link>
          </div>
        </div>

        {/* Footer */}
        <p className="mt-12 text-xs text-gray-400">
          C-Tribe Festival & Conference
        </p>
      </div>
    </div>
  );
}
